/**
 * @file 帮助指南文章页
 * @author wangzhuang
 */

import {rcAjax} from '../util';
import {GET_HELPAPI_GETTEXT} from './ActionTypes';

export function fetchHelpapiGettext(dispatch, obj) {
    return rcAjax('GET', `/helpapi/mobileGettext/${obj.urlId}`, {file_type: obj.fileType}, {}, data => {
        dispatch({type: GET_HELPAPI_GETTEXT, data: data.data});
    });
}



// WEBPACK FOOTER //
// ./src/actions/communityAction.js